import { DATE_DEBUT, DATE_FIN } from "../config";

export const IMAGES = {
  gilles:
    "https://customer-assets-jai6qajn.emergentagent.net/job_signal-interieur/artifacts/xyfrrp52_IMG_9886_%28www.vincentphotographie.com%29.jpg",
  heroDive:
    "https://static.prod-images.emergentagent.com/jobs/a81e6a11-e285-4919-bdc0-b96540109c86/images/c003d93edbe6951f3c69e9eaa144447fa109cf608ffe4c2f7c00c2270d4f0593.jpeg",
  immersion:
    "https://static.prod-images.emergentagent.com/jobs/a81e6a11-e285-4919-bdc0-b96540109c86/images/7ed3e8d043a5defb0ebfb19ae33e2740419ea03fe1c48d7a4c7c177ac512d35f.jpeg",
  face:
    "https://static.prod-images.emergentagent.com/jobs/a81e6a11-e285-4919-bdc0-b96540109c86/images/522aeebc20dcdb99cb34c2b18dc4b42a46670f194170199a4dad9a245b0146da.jpeg",
  dolphins:
    "https://static.prod-images.emergentagent.com/jobs/a81e6a11-e285-4919-bdc0-b96540109c86/images/f24796a500d9cbd8d584d9c814dd472bed2397baf9ff726c81b1410ecaa617ed.jpeg",
  depthRays:
    "https://static.prod-images.emergentagent.com/jobs/a81e6a11-e285-4919-bdc0-b96540109c86/images/3c1b2713e63b9b17509ae52d1dd6b45ec251831f43c595943eb92e898235e5c5.jpeg",
  shore:
    "https://static.prod-images.emergentagent.com/jobs/a81e6a11-e285-4919-bdc0-b96540109c86/images/f323ae12f30e551afa2a6897d60f952b5397057b945f6c594a95acddea123729.jpeg",
  group:
    "https://static.prod-images.emergentagent.com/jobs/a81e6a11-e285-4919-bdc0-b96540109c86/images/15da2a55373f8eba6ac9bab36f9fec53b5796d5af4aa388ce613c0a4650f21ad.jpeg",
  faceStill:
    "https://static.prod-images.emergentagent.com/jobs/a81e6a11-e285-4919-bdc0-b96540109c86/images/176ff5c0b0a4524ffd0813b9a339ac2163f32c3866ff725e00822e21c63609e8.jpeg",
  waterDetail:
    "https://static.prod-images.emergentagent.com/jobs/a81e6a11-e285-4919-bdc0-b96540109c86/images/2bc1d6506fe510d83e922b13e9fb686ea808c4463dd226285f6a9d50d1edeadf.jpeg",
};

export const BENEFITS = [
  {
    title: "Retrouver ton signal",
    text: "Différencier ce que tu ressens réellement du bruit, des injonctions, de la peur et des automatismes accumulés.",
  },
  {
    title: "Remettre du mouvement",
    text: "Sortir de l'attente intérieure sans te brutaliser ni te précipiter dans des décisions artificielles.",
  },
  {
    title: "Revenir au vivant",
    text: "Retrouver une relation plus sensible à ton corps, à ton intuition, au jeu, au lien et à l'instant.",
  },
  {
    title: "Faire un premier choix",
    text: "Ne pas tout résoudre en sept jours, mais poser un geste suffisamment vrai pour modifier la suite.",
  },
];

export const PASSAGES = [
  {
    num: "01",
    title: "Le Plongeon",
    subtitle: "Quitter quelques instants la surface",
    image: IMAGES.depthRays,
    paragraphs: [
      "Le premier passage t'invite à observer ce qui occupe ton espace intérieur.",
      "Les habitudes. Le bruit. Les automatismes. Les fidélités invisibles. Les décisions suspendues.",
      "Non pour les combattre, mais pour cesser de les confondre avec toi.",
      "Plonger, ici, ne signifie pas fuir le monde. Cela signifie descendre sous le commentaire permanent afin de retrouver une perception plus directe de ce que tu vis.",
    ],
    items: [
      "Identifier ce qui brouille actuellement ton signal.",
      "Revenir à une écoute plus incarnée.",
      "Créer un espace entre la peur et la décision.",
    ],
    ambiance: "Passage de la surface vers des profondeurs lumineuses.",
    tone: "abyss",
  },
  {
    num: "02",
    title: "La Rencontre",
    subtitle: "Retrouver ce qui cherche à vivre",
    image: IMAGES.dolphins,
    paragraphs: [
      "Lorsque le bruit diminue, quelque chose peut enfin se présenter.",
      "Un désir. Une fatigue devenue impossible à ignorer. Une direction. Une joie ancienne. Une décision que tu connaissais déjà sans avoir encore osé la reconnaître.",
      "La Rencontre n'est pas une injonction à changer toute ta vie.",
      "C'est l'instant où tu cesses de détourner les yeux de ce qui est vivant.",
    ],
    items: [
      "Distinguer l'élan profond de l'impulsion passagère.",
      "Rencontrer une part de toi moins administrée.",
      "Retrouver la possibilité du jeu, du lien et de la surprise.",
    ],
    ambiance: "Présence humaine dans l'eau, lumière plus chaude, mouvement collectif.",
    tone: "marine",
  },
  {
    num: "03",
    title: "Le Rivage",
    subtitle: "Ramener l'expérience dans ta vie",
    image: IMAGES.shore,
    paragraphs: [
      "Une prise de conscience qui ne touche jamais le réel devient vite une jolie pensée rangée sur une étagère intérieure.",
      "Le Rivage est le passage de l'expérience au choix.",
      "Tu seras invité à identifier ce que tu veux préserver, nourrir, modifier ou commencer.",
      "Pas dans six mois. Pas lorsque tout sera parfaitement aligné. À l'endroit exact où tu te trouves.",
    ],
    items: [
      "Transformer un ressenti en premier geste concret.",
      "Choisir sans attendre la disparition totale de la peur.",
      "Revenir dans ta vie avec davantage de présence et de responsabilité.",
    ],
    ambiance: "Retour vers la lumière, marche sur le rivage, horizon ouvert, aube claire.",
    tone: "sand",
  },
];

export const IDENTIFICATION = [
  "Tu n'as pas forcément besoin d'une nouvelle méthode. Tu as besoin de ressentir à nouveau ce qui est vrai pour toi.",
  "Tu sais prendre soin des autres, mais tu ne sais plus toujours ce qui prend réellement soin de toi.",
  "Tu ressens qu'un mouvement devient nécessaire, sans encore savoir quelle forme il doit prendre.",
  "Tu as parfois l'impression d'attendre que la peur disparaisse avant de commencer à vivre autrement.",
  "Tu ne veux plus seulement comprendre ta vie. Tu veux la rencontrer.",
  "Une part de toi sait déjà. Mais elle parle moins fort que le bruit accumulé autour d'elle.",
];

export const BETWEEN = [
  {
    title: "Des expériences guidées",
    text: "Des explorations simples pour observer, ressentir, écrire, marcher, respirer, choisir ou déplacer ton regard.",
  },
  {
    title: "Un groupe privé",
    text: "Un espace réservé aux participants pour recevoir les indications, partager certaines prises de conscience et rester relié à la dynamique collective.",
  },
  {
    title: "Les replays",
    text: "Les trois grandes soirées resteront disponibles afin que tu puisses les vivre ou les revoir dans de bonnes conditions.",
  },
  {
    title: "Un fil rouge",
    text: "Chaque étape prépare la suivante et crée une progression cohérente pendant les sept jours.",
  },
];

export const PACT = [
  "réserver de vrais espaces pour les trois soirées ou leurs replays ;",
  "vivre les expériences proposées entre les rendez-vous ;",
  "ne pas chercher à tout comprendre avant d'avoir ressenti ;",
  "respecter ton rythme sans utiliser ton rythme comme une nouvelle manière de toujours remettre à demain ;",
  "entrer dans l'expérience avec curiosité, honnêteté et responsabilité.",
];

export const STATS = [
  { value: "25", label: "ans d'accompagnement" },
  { value: "19", label: "ans de cheminement avec les dauphins" },
  { value: "11", label: "ans de voyages à leur rencontre physique" },
];

export const REASSURANCE = [
  "l'accès aux trois grandes soirées en ligne",
  "les liens de connexion",
  "les expériences guidées entre les rendez-vous",
  "l'accès au groupe privé",
  "les replays",
  "les informations nécessaires pour avancer pendant les sept jours",
];

export const FAQ = [
  {
    q: "La Traversée est-elle réellement gratuite ?",
    a: "Oui. L'accès aux trois soirées, aux expériences proposées, au groupe privé et aux replays est offert. La seule contrepartie demandée est un engagement sincère à ne pas traiter cette expérience comme un contenu de plus à collectionner.",
  },
  {
    q: "Dois-je être présent en direct ?",
    a: "La présence en direct est recommandée pour profiter de la dynamique collective, mais les replays seront disponibles. Tu pourras donc vivre les rendez-vous dans de bonnes conditions si ton emploi du temps ne te permet pas d'être présent.",
  },
  {
    q: "Ai-je besoin d'une expérience en méditation ou en développement personnel ?",
    a: "Non. Les expériences seront guidées de manière simple et accessible. Elles ne nécessitent aucune connaissance particulière.",
  },
  {
    q: "Est-ce une thérapie ?",
    a: "Non. La Traversée est une expérience de réflexion, de présence et d'exploration personnelle. Elle ne remplace pas un accompagnement médical, psychologique ou thérapeutique lorsque celui-ci est nécessaire.",
  },
  {
    q: "Que signifie l'énergie des Maîtres Dauphins ?",
    a: "Cette expression désigne l'approche symbolique, sensible et spirituelle développée par Gilles Delieuze autour des qualités que les dauphins peuvent évoquer : présence, lien, intelligence collective, mouvement, jeu et relation au vivant. Elle n'est pas présentée comme une affirmation scientifique ou médicale.",
  },
  {
    q: "Combien de temps dois-je prévoir ?",
    a: "Prévois du temps pour les trois grandes soirées ainsi que quelques moments courts entre les rendez-vous. Les expériences intermédiaires sont conçues pour pouvoir entrer dans une vie réelle, pas dans un agenda imaginaire où tu aurais soudainement quatorze heures libres par jour.",
  },
  {
    q: "Où se déroule l'expérience ?",
    a: "Les trois grandes soirées se déroulent en ligne. Les informations de connexion et l'accès au groupe privé seront envoyés après ton inscription.",
  },
  {
    q: "Quand commence La Traversée ?",
    a: `La Traversée se déroulera du ${DATE_DEBUT} au ${DATE_FIN}. Les horaires précis des trois grandes soirées seront indiqués dans l'email de confirmation.`,
  },
];
